"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithUseToolbarState = exports.useToolbarState = void 0;
var react_1 = require("react");
var slate_react_1 = require("slate-react");
var Utils_1 = require("../Utils");
function usePrevious(value) {
    var ref = (0, react_1.useRef)();
    (0, react_1.useEffect)(function () {
        ref.current = value;
    });
    return ref.current;
}
var useToolbarState = function (isSelected, isVoidWidget) {
    var _a = __read((0, react_1.useState)(false), 2), usingToolbar = _a[0], setUsingToolbar = _a[1];
    var editor = (0, slate_react_1.useSlate)();
    var selection = editor.selection;
    var previousIsSelected = usePrevious(isSelected);
    var previousSelection = usePrevious(selection);
    var justBlurred = previousIsSelected && previousSelection && !isSelected && !selection && !usingToolbar;
    (0, react_1.useEffect)(function () {
        var shouldTriggerUsingMenu = justBlurred;
        if (shouldTriggerUsingMenu) {
            setUsingToolbar(true);
            return;
        }
        var checkSelection = !!selection && usingToolbar;
        if (checkSelection) {
            if (!isSelected) {
                setUsingToolbar(false);
                return;
            }
            if (isVoidWidget) {
                return;
            }
            var inDummyBlock = (0, Utils_1.checkAncestors)(editor, selection.focus.path, Utils_1.isDummyBlockElement);
            if (!inDummyBlock) {
                setUsingToolbar(false);
            }
        }
    });
    var computedToolbarBeingUsed = usingToolbar || justBlurred;
    return !!computedToolbarBeingUsed;
};
exports.useToolbarState = useToolbarState;
var WithUseToolbarState = function (_a) {
    var isSelected = _a.isSelected, isVoidWidget = _a.isVoidWidget, render = _a.children;
    var isUsingToolbar = useToolbarState(isSelected, isVoidWidget);
    return render({
        isUsingToolbar: isUsingToolbar,
    });
};
exports.WithUseToolbarState = WithUseToolbarState;
